const formatInteger = (val) => {
    if (val === null || val === undefined) {
        return null;
    }
    return val;
}

export default formatInteger;